import { render, staticRenderFns } from "./MaterialExport.vue?vue&type=template&id=55f70577&scoped=true"
import script from "./MaterialExport.vue?vue&type=script&lang=js"
export * from "./MaterialExport.vue?vue&type=script&lang=js"
import style0 from "./MaterialExport.vue?vue&type=style&index=0&id=55f70577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f70577",
  null
  
)

export default component.exports